import React from 'react';
import { motion } from 'framer-motion';
import Seo from '../components/Seo';
import { VideoBlock } from '../components/VideoBlock';
import { REELS } from '../data/reels';
import { CreditCard } from 'lucide-react';

const FinancingPage = () => {
  const financingOptions = [
    { 
      name: 'LightStream', 
      href: 'https://www.lightstream.com/hot-tub-financing', 
      desc: 'Hot Tub Financing made simple',
      image: 'https://customer-assets.emergentagent.com/job_c9fc35cc-a79d-4aa5-bc5f-c10dcad10f37/artifacts/ts5ulh1y_unnamed.jpg'
    },
    { 
      name: 'HFS Financial', 
      href: 'https://www.hfsfinancial.net/promo/681a2e80e67418f6142e1b65/', 
      desc: 'Swimming Pool & Hot Tub Financing',
      image: 'https://customer-assets.emergentagent.com/job_c9fc35cc-a79d-4aa5-bc5f-c10dcad10f37/artifacts/jszwdq7c_unnamed-1.jpg'
    },
  ];

  return (
    <>
      <Seo page="/financing" />

      <div className="pt-36 pb-20" style={{ 
        background: 'linear-gradient(180deg, #ffffff 0%, #E0FFFF 20%, #AFEEEE 50%, #98FB98 80%, #F0FFF0 100%)' 
      }} data-testid="financing-page">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          {/* Hero Section */}
          <motion.div 
            initial={{ opacity: 0, y: 20 }} 
            animate={{ opacity: 1, y: 0 }}
            className="text-center mb-12"
          >
            <h1 className="font-['Barlow_Condensed'] text-4xl md:text-6xl font-bold uppercase text-[#0E3D95] mb-6">
              Relax… We Have Flexible Payment Options
            </h1>
            
            <p className="text-xl md:text-2xl text-slate-600 max-w-3xl mx-auto mb-8">
              Low monthly payment options on approved credit for our hot tubs, swim spas, cold plunges, and saunas!
            </p>

            {/* Choose Provider Text */}
            <div className="flex items-center justify-center gap-3 mb-8">
              <div className="w-16 h-0.5 bg-[#0E3D95]"></div>
              <h2 className="font-['Barlow_Condensed'] text-2xl md:text-3xl font-bold uppercase text-[#0E3D95]">
                Choose Our Financial Lending Provider Below
              </h2>
              <div className="w-16 h-0.5 bg-[#0E3D95]"></div>
            </div>
          </motion.div>
          
          {/* Financing Cards with Images */}
          <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto">
            {financingOptions.map((fin, idx) => (
              <motion.a 
                key={fin.name} 
                href={fin.href} 
                target="_blank" 
                rel="noopener noreferrer" 
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: idx * 0.1 }}
                whileHover={{ y: -5, scale: 1.02 }} 
                className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all block group"
              >
                {/* Image */}
                <div className="relative h-64 overflow-hidden">
                  <img 
                    src={fin.image} 
                    alt={fin.name}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
                </div>
                
                {/* Card Body */}
                <div className="p-6 text-center">
                  <div className="flex items-center justify-center gap-2 mb-3">
                    <CreditCard className="w-6 h-6 text-[#0E3D95]" />
                    <h3 className="font-['Barlow_Condensed'] text-2xl font-bold text-[#0E3D95]">{fin.name}</h3>
                  </div>
                  <p className="text-slate-600 mb-4">{fin.desc}</p>
                  
                  {/* CTA Button */}
                  <span className="inline-flex items-center gap-2 bg-[#F88200] hover:bg-[#e07600] text-white font-bold py-3 px-8 rounded-lg transition-colors">
                    Apply Now →
                  </span>
                </div>
              </motion.a>
            ))}
          </div>

          <VideoBlock eyebrow="Factory-Direct Pricing" reel={REELS.dolphin} testId="financing-dolphin-video" />
        </div>
      </div>
    </>
  );
};

export default FinancingPage;
